import { SymbolAndOptionalExchangeCode } from '../../models/fundamental/types';
import { GWMarketDataSummaryBucket } from '../../models/gateway/types';
import { BBOData, OHLCV, SymbolStatus, TradeData } from '../../models/market-data/types';
import { NullableNumber } from '../../util/types';

export interface BasicSymbolStat {
  open: NullableNumber;
  low: NullableNumber;
  high: NullableNumber;
  prevClose: NullableNumber;
  prevVolume: NullableNumber;
}

export type InstrumentSnapshotData = {
  sym: string
  absoluteChange: NullableNumber
  askPrice: NullableNumber
  bidPrice: NullableNumber
  date: string
  lastPrice: NullableNumber
  percentageChange: NullableNumber
  prevAbsoluteChange: NullableNumber
  prevClose: NullableNumber
  prevDate: string
  prevHigh: NullableNumber
  prevLastPrice: NullableNumber
  prevLow: NullableNumber
  prevOpen: NullableNumber
  prevPercentageChange: NullableNumber
  prevVolume: NullableNumber
  sumPriceXSize: NullableNumber
  // the following properties marked with ? are sometimes not available
  open?: NullableNumber
  high?: NullableNumber
  low?: NullableNumber
  close?: NullableNumber
  volume?: NullableNumber
}
export type InstrumentSnapshotMap = { [symbol: string]: InstrumentSnapshotData }
export type BBODataCache = { [symbol: string]: BBOData };
export type TradeDataCache = { [symbol: string]: TradeData };
export type SymbolStatusDataCache = { [symbol: string]: SymbolStatus };

/**
 * Groups define collection of symbol for easier subscription management.
 */
export type SubscribeGroup = (
  'initial'
  | 'watchlist'
  | 'discover'
  | 'symbol-details'
  | 'my-account'
  | 'history'
  | 'create-order'
  | 'funds'
  | 'profile'
  | 'modify-order'
  | 'people-also-trade'
  | 'chart-details'
)

export enum SymbolFavoriteListActionType {
  Add,
  Remove,
}

export type SymbolFavoriteListPayload = {
  userCorrelationId?: number
  symbolAndExchange: SymbolAndOptionalExchangeCode
  actionType: SymbolFavoriteListActionType
}

export type MultipleOHLCVDataForPriceCalculation = {
  bucket: GWMarketDataSummaryBucket
  data: { [symbol: string]: OHLCV[] }
}

export type OHLCVDataForPriceCalculation = {
  bucket: GWMarketDataSummaryBucket
  data: OHLCV[]
  symbol?: string
}

export type SymbolLite = {symbol: string};
export type UserFavoriteStocks = {[id: number]: SymbolAndOptionalExchangeCode[]};
export type UserRecentlyViewedStocks = {[id: number]: SymbolAndOptionalExchangeCode[]};

export type AddSymbolToRecentlyViewedPayload = {
  userCorrelationId?: number
  symbolAndExchange: SymbolAndOptionalExchangeCode
}
